module.exports = __webpack_public_path__ + "static/img/8.2b568e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/16/eng/8.png
// module id = 1iJE
// module chunks = 0